/**
 * V2.0.50 — Reusable public-facing footer.
 *
 * Pinned to the bottom of public/marketing routes (Landing,
 * LocalCodeFinder, TermsOfService, PrivacyPolicy). Solid black
 * background, white text, brass accent on hover. Responsive: stacks
 * vertically on mobile, single row on md+.
 *
 * Does NOT include the editor / dashboard chrome — those routes have
 * their own header/footer system.
 */
import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="public-footer"
      className="w-full bg-[#1c1610] border-t border-brass-900/40 py-8 px-6 lg:px-12 mt-auto"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div
          data-testid="public-footer-copyright"
          className="font-mono text-[10px] uppercase tracking-widest text-zinc-100"
        >
          © {year} Blueprint AI LLC · All rights reserved
        </div>

        <nav
          aria-label="Footer"
          className="flex flex-wrap items-center gap-x-5 gap-y-2 font-mono text-[10px] uppercase tracking-widest"
        >
          <Link
            to="/terms"
            data-testid="public-footer-terms-link"
            className="text-zinc-100 hover:text-brass-400 transition-colors"
          >
            Terms of Service
          </Link>
          <span className="text-zinc-700" aria-hidden="true">·</span>
          <Link
            to="/privacy"
            data-testid="public-footer-privacy-link"
            className="text-zinc-100 hover:text-brass-400 transition-colors"
          >
            Privacy Policy
          </Link>
          <span className="text-zinc-700" aria-hidden="true">·</span>
          <a
            href="mailto:jonathan@blueprintaillc.com"
            data-testid="public-footer-support-email"
            className="text-zinc-100 hover:text-brass-400 transition-colors normal-case tracking-normal"
          >
            jonathan@blueprintaillc.com
          </a>
        </nav>
      </div>
    </footer>
  );
}
